import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./slices/authSlice";
import { profileReducer } from "./slices/profileSlice";
import { doctorsReducer } from "./slices/doctorsSlice";
import { departmentReducer } from "./slices/departmentSlice";
import { cityReducer } from "./slices/citySlice";
import { commentReducer } from "./slices/commentSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    profile: profileReducer,
    doctor: doctorsReducer,
    department: departmentReducer,
    city: cityReducer,
    comment: commentReducer,
  },
});

export default store;
